import Shared from '../shared.module.css';
import Styles from './styles.module.css';
import React, { useState, useRef, useEffect } from 'react';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import { BsThreeDots } from 'react-icons/bs';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import DefaultImage from 'src/image/default/account.png';

type StaffCardProps = {
  // メニューの「編集する」
  onEdit: () => void;
  staff: {
    id: string;
    docId: string;
    name: string;
    position: string;
    message: string;
    instagramId: string;
    tiktokId: string;
  };
};

// 元 12.staffProfiles/1.item/index.tsx の削除処理・表示項目をそのまま引き継ぎ、
// テーブル行からカードのレイアウトに変更しただけ。「編集する」で登録時と同じ画面を開いて編集できる。
const StaffCard: React.FC<StaffCardProps> = ({ staff, onEdit }) => {

  const db = getFirestore();

  const [ visible, setVisible ] = useState(false);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const divRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        divRef.current && !divRef.current.contains(event.target as Node) &&
        buttonRef.current && !buttonRef.current.contains(event.target as Node)
      ) {
        setVisible(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleButtonClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setVisible((prev) => !prev);
  };

  const deleteDocument = async () => {
    await deleteDoc(doc(db, 'staffProfiles', staff.id));
  };

  const imageUrl = `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/staffProfiles%2F${staff.docId}?alt=media`;

  const hasSns = Boolean(staff.instagramId || staff.tiktokId);

  return (
    <div className={Shared.card}>
      <div className={Styles.avatarWrap}>
        <img className={Styles.avatar} src={imageUrl} alt={staff.name}
          onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = DefaultImage;
          }}
        />
      </div>

      <h4 className={Styles.name}>{staff.name}</h4>
      {staff.position && <span className={Styles.positionBadge}>{staff.position}</span>}
      {staff.message && <p className={Styles.message}>{staff.message}</p>}

      {hasSns && (
        <div className={Styles.snsRow}>
          {staff.instagramId && (
            <a
              className={Styles.snsIcon}
              href={`https://instagram.com/${staff.instagramId}`}
              target="_blank"
              rel="noreferrer noopener"
              onClick={(e) => e.stopPropagation()}
              title={`@${staff.instagramId}`}
            >
              <FaInstagram />
            </a>
          )}
          {staff.tiktokId && (
            <a
              className={Styles.snsIcon}
              href={`https://www.tiktok.com/@${staff.tiktokId}`}
              target="_blank"
              rel="noreferrer noopener"
              onClick={(e) => e.stopPropagation()}
              title={`@${staff.tiktokId}`}
            >
              <FaTiktok />
            </a>
          )}
        </div>
      )}

      <div className={Shared.cardActions}>
        <div className={Shared.cardMenuBtn} ref={buttonRef} onClick={handleButtonClick}>
          <BsThreeDots />
          {visible && (
            <div className={Shared.cardMenuPopover} ref={divRef}>
              <p onClick={() => { setVisible(false); onEdit(); }}>編集する</p>
              <p onClick={() => deleteDocument()}>削除する</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffCard;
